export const RECRUITMENT_INQUIRY = '/recruitment/inquiry'
